import React, { useMemo, useState, useCallback } from "react";
import DOMPurify from "dompurify";
import styles from "./Answer.module.css";
import { AskResponse } from "../../api";
import AnswerBox from "./AnswerBox"; // Import the new component
import { parseAnswerToHtml } from "./AnswerParser";
import FeedbackButtons from "./FeedbackButtons";

import { useSelector } from "react-redux";
import { RootState } from "@/store";

interface Props {
    answer: AskResponse;
    isSelected?: boolean;
    onSuggestionClicked?: (question: string) => void;
    showFollowupQuestions?: boolean;
    likeCall: (like: boolean, iteration_id: string) => void;
}

// interface SuggestionModel {
//     text: string;
//     value: string;
//     id: string;
// }

// const adaptDataToSuggestionModel = (data: string[]): SuggestionModel[] => {
//     return data.map((item, index) => ({
//         text: item,
//         value: item,
//         id: index.toString()
//     }));
// };

export const Answer = React.memo(({ answer, isSelected, onSuggestionClicked, showFollowupQuestions, likeCall }: Props) => {
    const [like, setLike] = useState<boolean | null>(null);
    const isStreaming = useSelector((state: RootState) => state.values.isStreaming);

    const parsedAnswer = useMemo(() => parseAnswerToHtml(answer.chat_message), [answer]);

    const sanitizedAnswerHtml = useMemo(() => DOMPurify.sanitize(parsedAnswer.answerHtml, { ADD_ATTR: ["target"] }), [parsedAnswer]);

    // const adaptedFollowupQuestions = useMemo(() => adaptDataToSuggestionModel(parsedAnswer.followupQuestions), [parsedAnswer]);

    const onLike = useCallback(() => {
        setLike(true);
        likeCall(true, answer.iteration_id);
    }, [likeCall, answer.iteration_id]);

    const onDislike = useCallback(() => {
        setLike(false);
        likeCall(false, answer.iteration_id);
    }, [likeCall, answer.iteration_id]);

    return (
        <div className={styles.container}>
            <div className={`${styles.answer} ${isSelected ? styles.selected : ""}`}>
                <AnswerBox sanitizedAnswerHtml={sanitizedAnswerHtml} isStreaming={isStreaming} showAvatar={true} />
                {!isStreaming && (
                    <div id="answerFeedback" className={styles.answerFeedback}>
                        <FeedbackButtons like={like} onLike={onLike} onDislike={onDislike} />
                    </div>
                )}
            </div>
            {/* {adaptedFollowupQuestions.length > 0 && showFollowupQuestions && onSuggestionClicked && (
                <div className={styles.followupContainer}>
                    <div className={styles.suggestionsWrapper}>
                        <Suggestions data={adaptedFollowupQuestions} onSuggestionClicked={onSuggestionClicked} />
                    </div>
                </div>
            )} */}
        </div>
    );
});
